import de from './de';
import fr from './fr';

export default {
  de,
  fr
};
